import {
  customEval,
  isArrayWithPrimitive,
  isPrimitiveValue,
  mString,
  removeHtmlTags
} from 'lib/helpers/utility';

export const getNestedValue = (nestedValue) => {
  // if its object with value and href, example in reports
  if (nestedValue !== undefined) {
    if (typeof nestedValue !== 'object') {
      return nestedValue;
    }

    const formatted = Object.entries(nestedValue)
      .map(([key, val]) => {
        if (typeof val === 'number' && !key.endsWith('_') && !key.includes('_id')) {
          return mString(val);
        }

        return val;
      })
      .join(' / ');

    return formatted;
  }
};

export default function extractDataFromColDefs(data, colDefs) {
  return data.map((row) => {
    const result = {};

    colDefs.forEach(({ field, valueFormatter, valueGetter }) => {
      if (!field) return;

      let rawValue = customEval(row, field);

      if (typeof rawValue === 'string') {
        rawValue = removeHtmlTags(rawValue);
      }

      if (valueGetter) {
        result[field] = valueGetter({ value: rawValue, data: row });
        return;
      }

      if (valueFormatter) {
        const formattedValue = valueFormatter({ value: rawValue, data: row });

        if (formattedValue) {
          result[field] = formattedValue;
          return;
        }
      }

      if (isPrimitiveValue(rawValue)) {
        result[field] = rawValue;
        return;
      }

      if (isArrayWithPrimitive(rawValue)) {
        result[field] = rawValue.join(', ');
        return;
      }

      const nestedValue = getNestedValue(rawValue?.value);

      if (nestedValue) {
        result[field] = nestedValue;
        return;
      }

      result[field] = '-';
    });

    return result;
  });
}
